export enum HeaderTheme {
  black = 1,
  transparent = 2,
  gradient = 3,
}
